import React from "react";

function IconCongrats() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="240"
      height="240"
      viewBox="0 0 240 240"
      fill="none"
    >
      <g clip-path="url(#clip0_427_27716)">
        <mask
          id="mask0_427_27716"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="240"
          height="240"
        >
          <path d="M240 0H0V240H240V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_427_27716)">
          <path
            d="M202.779 97.5628C199.638 95.6647 195.68 93.2944 195.071 91.5644C194.943 88.1177 195.618 84.6938 197.036 81.5513C199.083 75.3602 201.195 68.9463 197.749 64.0901C194.301 59.2341 187.459 59.0224 180.888 58.9281C177.514 59.2133 174.117 58.7268 170.958 57.5004C169.174 54.6055 168.077 51.3415 167.756 47.9608C166.428 41.5175 165.05 34.8522 159.612 32.3187C154.177 29.7802 148.242 32.9823 142.532 36.1542C139.697 38.1179 136.446 39.404 133.033 39.9071C131.197 39.591 128.157 36.1629 125.734 33.4182C121.489 28.6738 116.718 23.2955 110.583 23.8577C104.448 24.42 100.73 30.5786 97.4459 36.0105C95.5389 39.1593 93.1749 43.1067 91.446 43.7279C88.0021 43.8338 84.5737 43.1623 81.4255 41.7613C75.1994 39.6736 68.7902 37.6123 63.9493 41.042C59.1083 44.4693 58.8743 51.3305 58.7433 57.9484C59.0284 61.3229 58.5444 64.7196 57.3229 67.8803C54.4449 69.6383 51.2036 70.7186 47.8474 71.0454C41.397 72.374 34.724 73.7471 32.1977 79.1844C29.6689 84.6218 32.8706 90.5512 36.0434 96.2711C38.0148 99.1103 39.3017 102.371 39.8009 105.794C39.4826 107.633 36.0552 110.68 33.312 113.093C28.5619 117.302 23.1873 122.087 23.7496 128.222C24.3118 134.357 30.4713 138.085 35.9095 141.359C39.0505 143.259 43.0057 145.63 43.6173 147.36C43.7426 150.804 43.0708 154.23 41.6525 157.373C39.6047 163.561 37.4932 169.975 40.939 174.834C44.3846 179.69 51.2268 179.902 57.8002 179.993C61.1747 179.708 64.5719 180.197 67.728 181.421C69.5118 184.319 70.6084 187.58 70.9329 190.963C72.2609 197.406 73.6355 204.07 79.0736 206.605C84.5119 209.144 90.3891 205.872 96.1119 202.73C98.9771 200.781 102.249 199.51 105.678 199.005C107.517 199.323 110.557 202.749 112.98 205.494C117.194 210.241 121.972 215.619 128.105 215.057C134.24 214.494 137.958 208.336 141.242 202.904C143.149 199.755 145.513 195.808 147.242 195.189C150.687 195.068 154.115 195.737 157.262 197.153C163.448 199.201 169.858 201.296 174.712 197.875C179.563 194.456 179.789 187.586 179.923 181.002C179.638 177.625 180.122 174.23 181.344 171.072C184.226 169.302 187.473 168.209 190.841 167.878C197.291 166.55 203.964 165.174 206.491 159.737C209.019 154.3 205.747 148.42 202.615 142.696C200.647 139.84 199.371 136.566 198.89 133.13C199.203 131.291 202.631 128.247 205.379 125.828C210.123 121.612 215.51 116.829 214.948 110.701C214.387 104.573 208.217 100.839 202.779 97.5628Z"
            fill="#D79A2B"
          />
          <path
            d="M96.5189 138.518L79.7189 121.718C77.4005 119.4 73.6373 119.4 71.3189 121.718C69.0005 124.039 69.0005 127.797 71.3189 130.118L96.5189 155.318C98.8373 157.639 102.6 157.639 104.919 155.318L168.519 91.7179C170.84 89.3995 170.84 85.6363 168.519 83.3179C166.198 80.9995 162.44 80.9995 160.119 83.3179L104.919 138.518C102.6 140.839 98.8373 140.839 96.5189 138.518Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_427_27716">
          <rect width="240" height="240" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconCongrats;
